import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-banner',
  templateUrl: './global-banner.component.html',
  styleUrls: ['./global-banner.component.scss'],
})
export class GlobalBannerComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
